import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=47a96c23"
import script from "../../controllers/teacher/teacher-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher/teacher-list.js?vue&type=script&lang=js&external"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=47a96c23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports